import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';

import { borderColor } from './common';

const EAA_Time = ({
  disabled = false,
  displayBorder = false,
  value = new Date(),
  onChange = () => {},
  error = false,
  inputFormat = 'yyyy/MM/dd HH:mm',
  hint = '年/月/日 時:分',
}) => {
  const [over, setOver] = useState(false);
  const [focus, setFocus] = useState(false);
  const [open, setOpen] = useState(false);
  const views = [];
  if (inputFormat.match('yyyy'))views.push('year');
  if (inputFormat.match('MM'))views.push('month');
  if (inputFormat.match('dd'))views.push('day');
  if (inputFormat.match('HH'))views.push('hours');
  if (inputFormat.match('mm'))views.push('minutes');
  if (inputFormat.match('ss'))views.push('seconds');
  let mask = inputFormat;
  while (mask.match('y'))mask = mask.replace('y', '_');
  while (mask.match('M'))mask = mask.replace('M', '_');
  while (mask.match('d'))mask = mask.replace('d', '_');
  while (mask.match('H'))mask = mask.replace('H', '_');
  while (mask.match('m'))mask = mask.replace('m', '_');
  while (mask.match('s'))mask = mask.replace('s', '_');
  return (
    <div style={{ flex: 1, marginRight: 50 }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateTimePicker
          inputFormat={inputFormat}
          mask={mask}
          readOnly={disabled}
          views={views}
          onOpen={() => { setFocus(true); setOpen(true); }}
          onClose={() => { setFocus(false); setOpen(false); }}
          open={open}
          renderInput={params => (
            <TextField
              {...params}
              onClick={() => setOpen(true)}
              variant='standard'
              style={{
                backgroundColor: disabled ? '#ededed' : 'white',
                width: '100%',
                height: 46,
                textAlign: 'start',
                borderRadius: 14,
                border: ((displayBorder || over || focus || error) && !disabled) ? `1px solid ${(over || focus) ? 'black' : (error ? 'red' : borderColor)}` : '',
              }}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
                style: {
                  width: '100%',
                  height: 46,
                  paddingLeft: 12,
                  paddingRight: 12,
                  fontSize: 18,
                  letterSpacing: '0.15px',
                  color: error ? 'red' : (value !== '' ? 'black' : 'gray'),
                },
              }}
              inputProps={{
                ...params.inputProps,
                placeholder: hint,
                readOnly: true,
              }}
              onMouseOver={() => setOver(true)}
              onMouseOut={() => setOver(false)}
              onBlur={() => setFocus(false) }
              onFocus={() => setFocus(true)}
            />
          )}
          value={value}
          onChange={onChange}
        />
      </LocalizationProvider>
    </div>
  );
};

export default EAA_Time;
